import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isExpanded,
          expression: "isExpanded",
        },
      ],
      staticClass: "summary-header volume-funding__header",
    },
    [
      _c("div", { staticClass: "summary-header__title" }, [
        _c("label", { staticClass: "summary-header__label" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.params.displayName) + "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "summary-header__info" }, [
        _vm._v("\n        " + _vm._s(_vm.formattedValue) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.hasOverwriteVolumes
        ? [
            _c("div", { staticClass: "summary-header__reason-title" }, [
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm._f("toSentenceCase")(
                        _vm.$t(
                          "planning.promotionsMaintenance.funding.overWriteReason"
                        )
                      )
                    ) +
                    ":\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "summary-header__container" },
              [
                _c(
                  VTooltip,
                  {
                    attrs: {
                      "z-index": "400",
                      top: "",
                      "max-width": 200,
                      disabled: !_vm.toolTipValue,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "div",
                                _vm._g({}, on),
                                [
                                  _c(
                                    "vuex-select",
                                    _vm._b(
                                      {
                                        staticClass: "summary-header__reason",
                                        attrs: {
                                          "item-text": "text",
                                          options: _vm.overwriteReasonOptions,
                                          "vuex-module": "promotions",
                                          "field-name":
                                            _vm.overWriteReasonFieldName,
                                          filled: "",
                                          namespace: _vm.params.promotionId,
                                          validations: _vm.validationRules,
                                          "validate-on-blur": false,
                                          "ignore-parent-read-only":
                                            _vm.overwriteReasonReadOnlyIgnore,
                                          "force-validate-on-mount": "",
                                          tab: "funding",
                                        },
                                      },
                                      "vuex-select",
                                      attrs,
                                      false
                                    )
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      100958952
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.toolTipValue) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }